import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-print-receipt',
  templateUrl: './print-receipt.component.html',
  styleUrls: ['./print-receipt.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class PrintReceiptComponent implements OnInit {

	@Input() situation: string;

  constructor(private router: Router) { }

	ngOnInit() {
  }

	redirectToReceipt(): void{
		this.router.navigate(['comprovantes/transacao']);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/receipts/print-receipt/print-receipt.component.ts